export function disableSanitizingHTMLWarning() {
    const originalWarn = console.warn;
    console.warn = function (...args) {
      if (typeof args[0] === 'string' && args[0].includes('sanitizing HTML')) {
        return;
      }
      originalWarn.apply(console, args);
    };
  }
  